<template>
  <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
       aria-labelledby="productModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="maxWidth: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="productModalLabel">
            Просмотр товаров в заказе</h5>
          <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div class="modal-body">
          <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div v-if="this.orderDataIsLoading">
              <CircleProgress/>
            </div>
          </transition>

          <div class="client-info"> Клиент: <span class="text-normal">{{this.clientName}}</span></div>
          <div class="client-info"> Телефон: <span class="text-normal">{{this.clientPhone}}</span></div>

          <table class="products-preview">
            <thead>
            <tr>
              <th>Продукт</th>
              <th>Количество</th>
              <th>Скидка</th>
              <th>Цена</th>
              <th>Цена со скидкой</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in clientProducts.orderItems" :key="index">
              <td>{{ getProductNameById(item.productId) }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.discount }}%</td>
              <td>
                {{ getPriceWithoutDiscount(item.productId, item.quantity, clientProducts.rentStartDate, clientProducts.rentEndDate) }}
                BYN
              </td>
              <td>
                {{ getTotalPrice(item.productId, item.quantity, item.discount, clientProducts.rentStartDate, clientProducts.rentEndDate) }}
                BYN
              </td>
            </tr>
            </tbody>
          </table>
          <div class="sub-total"
               v-if="clientProducts.securityDepositAmount != null && clientProducts.securityDepositAmount != 0">ЗАЛОГ:
            {{
              clientProducts.securityDepositAmount.toFixed(2)
            }}
            BYN
          </div>
          <div class="sub-total" v-if="clientProducts.delivery != null && clientProducts.delivery != 0">ДОСТАВКА: {{
              clientProducts.delivery.toFixed(2)
            }}
            BYN
          </div>
          <div class="sub-total" v-if="clientProducts.sborka != null && clientProducts.sborka != 0">СБОРКА: {{
              clientProducts.sborka.toFixed(2)
            }}
            BYN
          </div>
          <div class="sub-total" v-if="clientProducts.ustanovka != null && clientProducts.ustanovka != 0">УСТАНОВКА: {{
              clientProducts.ustanovka.toFixed(2)
            }}
            BYN
          </div>
          <div style="margin-top: 16px;">ИТОГО: {{
              getTotalFinalPrice()
            }}
            BYN
          </div>
          <div style="margin-top: 8px;">С УЧЕТОМ СКИДКИ: {{ getTotalFinalDiscountPrice() }}
            BYN
          </div>
          <div style="color: #008a00;" class="sub-total"
               v-if="clientProducts.oplacheno != null && clientProducts.oplacheno != 0">ОПЛАЧЕНО: {{
              clientProducts.oplacheno.toFixed(2)
            }}
            BYN
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CircleProgress from "../CircleProgress.vue";
import velocity from "velocity-animate";
import axios from "@/axios";

export default {
  name: "ProductsInOrder",
  components: {
    CircleProgress
  },
  data() {
    return {
      products: [],
      formErrors: {
        name: false,
        equipmentCost: false,
        rentCost: false,
        qty: false
      },
    };
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.orderProductsModal;
      },
    },
    orderDataIsLoading: {
      get() {
        return this.$store.state.orderViewProductsIsLoading;
      },
    },
    clientProducts: {
      get() {
        return this.$store.state.orderProductsView;
      },
    },
    clientName: {
      get() {
        return this.$store.state.clientNameInOrder;
      }
    },
    clientPhone: {
      get() {
        return this.$store.state.clientPhoneInOrder;
      }
    }

  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    },
    fetchProducts() {
      let url = '/api/product';
      axios.get(url).then(response => {
        this.products = response.data;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    getOrderTotalPrice() {
      console.log("ORDERS IN MODAL: ", this.clientProducts)
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getTotalPrice(this.clientProducts[i].productId, this.clientProducts[i].quantity, this.clientProducts[i].discount));
      }
      return totalPrice.toFixed(2);
    },
    getProductNameById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].name;
        }
      }
      return 'Продукт не найден';
    },
    getTotalPrice(id, count, discount, start, end) {
      const days = this.getDaysDifference(start, end)
      const price = this.getProductPriceById(id);
      let totalPrice = count * price * days;
      if (discount !== 0) {
        totalPrice = totalPrice * (1 - discount / 100);
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getPriceWithoutDiscount(id, count, start, end) {
      const days = this.getDaysDifference(start, end)
      console.log("DAYS: " + start);
      const price = this.getProductPriceById(id);
      let totalPrice = count * price * days;
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    },
    getOrderTotalPriceWithoutDiscount() {
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getPriceWithoutDiscount(this.clientProducts[i].productId, this.clientProducts[i].quantity));
      }
      return totalPrice.toFixed(2);
    },
    getProductPriceById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].rentCost;
        }
      }
      return 0;
    },
    getDaysDifference(date1, date2) {
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      const diffInMilliseconds = Math.abs(d2 - d1);
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

      return diffInDays;
    },
    setShowModal(active) {
      this.$store.commit('updateOrderViewModal', active);
    },
    setIsLoading(active) {
      this.$store.commit('updateOrderViewDataIsLoading', active);
    },
    clearViewData() {
      this.$store.commit('updateOrderViewProducts', []);
    },
    closeModal() {
      this.setShowModal(false);
      this.clearViewData();
    },
    getTotalFinalPrice() {
      let total = this.clientProducts.paymentAmount;
      total = total.toFixed(2);
      return total;
    },
    getTotalFinalDiscountPrice() {
      let total = this.clientProducts.endPrice;
      total = total.toFixed(2);
      return total;
    },
  },
  mounted() {
    this.setIsLoading(true);
    this.fetchProducts();
    this.setIsLoading(false);
  }
}


</script>

<style scoped>


.products-preview {
  margin-top: 16px;
  width: 100%;
}
.client-info{
  color: #344767;
  font-weight: bolder;
}

td, th {
  width: auto;
  font-size: 0.8rem;
}

.sub-total {
  margin-top: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

</style>